// routes
import listRoutes from '../routes/listRoutes'

const LayoutProps = {
	[listRoutes.emailValidation]: {
		transparentHeader: true,
		logoColor: 'white',
		showMenu: false
	},
	[listRoutes.yourServices]: {},
	'/slide': {
		header: false,
		showMenu: false
	},
	[listRoutes.login]: {
		transparentHeader: true,
		logoColor: 'white',
		showMenu: false
	},
	'/informacion-inicial': {
		header: false,
		showMenu: false,
		hideNotification: true
	},
	[listRoutes.dailyInformation]: {
		goBack: true,
		header: true
	},
	[listRoutes.profile]: {
		chat: false
	},
	[listRoutes.myRoutine]: {
		logoColor: 'magenta'
	},
	[listRoutes.completeDataUser]: {
		goBack: true,
		header: true,
		showMenu: false
	},
	'/mi-rutina-personal': {
		goBack: true,
		header: true,
		showMenu: false
	},
	'/asistente-de-salud': {
		goBack: true,
		logoColor: 'magenta'
	},
	'/calendario': {
		backgroundClass: 'o-layout-bg-gray'
	},
	'/seleccion-de-rol': {
		transparentHeader: true,
		logoColor: 'white'
	},
	'/agregar-paciente': {
		goBack: true,
		showMenu: false
	},
	'/agregar-cuidador': {
		chat: false,
		goBack: true
	},
	'/validar-paciente-cuidador': {
		header: false,
		chat: false
	},
	'/calcular-imc': {
		goBack: true,
		controlBack: true,
		showMenu: false
	},
	'/herramientas/sos': {
		goBack: true,
		showMenu: false
	},
	'/herramientas/fast': {
		goBack: true,
		showMenu: false
	},
	'/herramientas/exam': {
		goBack: true,
		showMenu: false
	},
	'/herramientas/exam-read': {
		goBack: true,
		showMenu: false
	},
	'/herramientas/renovation': {
		goBack: true,
		showMenu: false
	},
	'/herramientas/orders': {
		goBack: true,
		showMenu: false
	},
	'/herramientas': {
		goBack: true,
		showMenu: false
	},
	[listRoutes.companyBenefits]: {
		goBack: true,
		showMenu: false
	},
	[listRoutes.lifestyleQuestionnaire]: {
		goBack: true,
		showMenu: false
	},
	'/plan/': {
		goBack: true,
		controlBack: true,
		showMenu: false
	},
	'/plan': {
		footer: false
	},
	'/par-q-public': {
		goBack: false,
		showMenu: false,
		logoColor: 'small'
	},
	'/par-q-public?client=cuestionario-vida': {
		transparentHeader: true,
		goBack: false,
		showMenu: false,
		showLogo: false
	},
	'/par-q-public?client=gimnasioscomfama': {
		transparentHeader: true,
		goBack: false,
		showMenu: false,
		showLogo: false
	},
	'/tu-condicion': {
		goBack: true,
		showMenu: false,
		backgroundClass: 'o-layout-bg-gray'
	},
	'/tus-habitos': {
		goBack: true,
		showMenu: true
	},
	'/habitos': {
		goBack: true,
		showMenu: true
	},
	'/red-de-cuidado/': {
		goBack: true,
		showMenu: true,
		backgroundClass: 'o-layout-bg-gray',
		controlBack: true
	},
	'/red-de-cuidado': {
		goBack: true,
		showMenu: true,
		backgroundClass: 'o-layout-bg-gray'
	},
	'/servicios': {
		goBack: true,
		showMenu: true
	},
	'/suscripcion': {
		goBack: true,
		showMenu: false
	},
	'/aliados': {
		goBack: true,
		showMenu: false
	},
	[listRoutes.completeDataUser]: {
		goBack: true,
		showMenu: true
	},
	'/envivos': {
		goBack: true,
		showMenu: false
	},
	'/formacion-cuidador': {
		goBack: true,
		showMenu: false
	},
	'/terminos-y-condiciones': {
		showMenu: false,
		transparentHeader: true,
		logoColor: 'white'
	},
	'/centros-de-cuidado/clases/': {
		goBack: true,
		showMenu: false
	},
	'/centros-de-cuidado/clases': {
		goBack: true
	},
	'/centros-de-cuidado/reserva-clases': {
		goBack: true,
		showMenu: false
	},
	'/centros-de-cuidado/reserva-bicicleta': {
		goBack: true,
		showMenu: false
	},
	[listRoutes.parQ]: {
		goBack: true
	},
	[listRoutes.parQWelcome]: {
		header: false,
		showMenu: false,
		transparentHeader: true,
		hideNotification: true,
		logoColor: 'white'
	},
	[listRoutes.appointment]: {
		goBack: true,
		controlBack: true,
		showMenu: false
	},
	[listRoutes.myAppointment]: {
		goBack: true,
		showMenu: false
	},
	[listRoutes.program]: {
		chat: false
	},
	[listRoutes.sadri]: {
		chat: false,
		goBack: true,
		showMenu: false
	},
	[listRoutes.programInternal]: {
		chat: false,
		goBack: true
	},
	[listRoutes.programSearch]: {
		chat: false,
		goBack: true
	},
	[listRoutes.programQualify]: {
		goBack: false,
		showMenu: false
	},
	[listRoutes.programInternal]: {
		goBack: true,
		showMenu: false
	},
	[listRoutes.pac]: {
		goBack: true,
		showMenu: false
	},
	[listRoutes.careShop]: {
		goBack: true,
		showMenu: false
	},
	[listRoutes.myServices]: {
		goBack: true,
		showMenu: false
	},
	default: {}
}

export default LayoutProps
